import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'map',
})
export class MapPipe implements PipeTransform {
  transform(array: any[], property: string): any[] {
    if (!Array.isArray(array)) {
      return array;
    }

    return array.map((item) => item[property]);
  }
}
